import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Modal, Select, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";

import Search from "antd/es/input/Search";
import {UserData} from "../DocumentMgr/data/UserData";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {formatDate} from "../../../../../Common/util/DateUtil";
import UserAvatar from "../../../index/Header/UserAvatar/UserAvatar";
import {procAdminService} from "../../../../../Common/util/ProcService";
import SelectBurk from "../../common/component/SelectBurk";
import SelectDept from "../../common/component/SelectDept";

const UserMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();
    const [ burkCD, setBurkCD] = useState<string>("");
    const [ deptCD, setDeptCD] = useState<string>("");
    const [ showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [ userStatus, setUserStatus] = useState<string>("");

    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`UserMgr`];
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    let requestParam:UserData = {
        deptCD:null,
        deptName:null,
        burkCd:null,
        burkName:null,
        userId:"",
        userName:null,
        password:null,
        userStatus:null,
        createTime:null,
        updateTime:null,
    };

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const [userStatusState, setUserStatusState] = useState<Record<string, boolean>>({});

    const { data, isFetching, refetch} = useCommonUseQuery<UserData[]>(
        queryKey,
        () =>procAdminService<UserData[]>("post", `${serviceCode}ADS10`, requestParam));


    const onSearch = (value: string) => {
        requestParam = {
            deptCD:deptCD,
            deptName:null,
            burkCd:burkCD,
            burkName:null,
            userId:value,
            userName:value,
            password:null,
            userStatus:userStatus === "" ? null : userStatus,
            createTime:null,
            updateTime:null,
        };

        refetch();
    }

    function onChangeDept(value:string)
    {
        setDeptCD(value);

    }

    function onChangeBurk(value:string)
    {
        setBurkCD(value);

    }

    function onChangeUserStatus(value:string)
    {
        setUserStatus(value);
    }

    const handleUserStatusChange = (record:UserData, checked: boolean) => {
        if (record.userId === "appdign")
        {
            return;
        }
        setUserStatusState((prev) => ({
            ...prev,
            [record.userId]: checked,
        }));

        // 서버로 변경된 extensionStatus 업데이트 요청을 보낼 수도 있습니다.
        updateUserStatus(record, checked);
    };

    function updateUserStatus(record:UserData, checked:boolean)
    {
        const updateUserParam:UserData  = {
            burkCd:record.burkCd,
            burkName:record.burkName,
            deptCD:record.deptCD,
            deptName:record.deptName,
            userId:record.userId,
            userName:record.userName,
            userStatus:checked ? "1" : "0",
            password:record.password,
            updateTime:null,
            createTime:null,
        }

        const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU02`, requestBody:updateUserParam }
        mutateUpdate.mutateAsync(updateParam)
            .catch(error => {
                console.error(error);

            }).finally(() => {
        })


    }

    const onInitPassword = (record:UserData) => {

        Modal.confirm({
            title: `${record.userName}(${record.userId})의 비밀번호를 초기화 하시겠습니까?`,
            content: "",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU13`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };


    useEffect(() => {
        // 최초 데이터 로딩 시 extensionStatusState 초기화
        if (data) {
            const initialState: Record<string, boolean> = {};
            data.forEach((item) => {
                initialState[item.userId] = item.userStatus === "1" ? true : false  || false;
            });
            setUserStatusState(initialState);
        }
    }, [data]);


    const columns: ColumnsType<UserData> = [
        {
            title: '',
            dataIndex: 'userName',
            key: 'userName',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <UserAvatar avatarText={text}/>
                </div>
            ,
        },
        {
            title: 'ID',
            dataIndex: 'userId',
            key: 'userId',
            render: (text: string, record:UserData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {record.userName} ({text})
                </div>
            ,
        },
        {
            title: '소속법인',
            dataIndex: 'burkCd',
            key: 'burkCd',
            render: (text: string,record:UserData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {record.burkName} ({text})
                </div>
            ,
        },
        {
            title: '소속부서',
            dataIndex: 'deptCD',
            key: 'deptCD',
            render: (text: string,record:UserData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {record.deptName} ({text})
                </div>
            ,
        },
        {
            title: '생성일자',
            key: 'createTime',
            dataIndex: 'createTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '마지막접속일자',
            key: 'updateTime',
            dataIndex: 'updateTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '비밀번호초기화여부',
            key: 'password',
            dataIndex: 'password',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox
                        checked={text === "init12345!"}
                    />
                </div>
            ,
        },
        {
            title: '관리자접근여부',
            key: 'userStatus',
            dataIndex: 'userStatus',
            render: (text: boolean, record:UserData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox
                        checked={userStatusState[record.userId]}
                        onChange={(e) => handleUserStatusChange(record, e.target.checked)}
                    />
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:UserData) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={()=>{onInitPassword(record)}}>비밀번호초기화</Button>
                </div>
            ,
        },
    ];


    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <SelectBurk onChangeValue={onChangeBurk}/>
                <SelectDept onChangeValue={onChangeDept}/>
                <Select
                    style={{width:"180px", marginRight:"10px"}}
                    placeholder={"관리자접근"}
                    options={[
                        {value:"", label:"전체"},
                        {value:"0", label:"일반"},
                        {value:"1", label:"관리자"},
                    ]}
                    onChange={onChangeUserStatus}
                />
                <Search placeholder="이름 또는 ID" allowClear onSearch={onSearch} style={{ width: 210 }} />
            </div>
        </nav>
        <Table columns={columns}
                dataSource={data}
                rowKey="userId"
                loading={isFetching}
        />
        </>
    );
};

export default UserMgr;
